export default __webpack_public_path__ + "static/media/property_785.b36fb679.png";